export const STAR_ICON = {
  defaultSize: 16
}